import { doBulkUpdate } from './doBulkUpdate'
import { doUnstar } from './doUnstar'

export const doBulkUnstar = (ticketIds, options = {}) => dispatch => {
  return dispatch(doBulkUpdate(ticketIds, doUnstar, [], options))
}
